import PropTypes from 'prop-types';

import React from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Card, CardContent, CardHeader, Divider, Typography } from '@mui/material';
import { Box } from '@mui/system';

// ==============================|| CUSTOM SUB CARD ||============================== //

const SubCard = React.forwardRef(
    (
        {
            border = true,
            boxShadow = false,
            children,
            content = true,
            contentClass = '',
            contentSX = {},
            darkTitle,
            secondary,
            shadow,
            sx = {},
            title,
            ...others
          },
         ref) => {
        const theme = useTheme();

        const borderColor =
      theme.palette.mode === 'dark' ? '#ffffff' : theme.palette.primary.main; // Change #ffffff to the exact color you want for white in dark mode

        return (
            <Card
                ref={ref}
                sx={{
                    border: border ? `1px solid ${borderColor}` : 'none',
                    ':hover': {
                      boxShadow: boxShadow
                        ? shadow ||
                          (theme.palette.mode === 'dark' ? '0 2px 14px 0 rgb(33 150 243 / 10%)' : '0 2px 14px 0 rgb(32 40 45 / 8%)')
                        : 'inherit',
                    },
                    ...sx
                }}
                {...others}
            >
                {/* card header and action */}
                {!darkTitle && title && (
                    <CardHeader sx={{ p: 2.5 }} title={<Typography variant="h5">{title}</Typography>} action={secondary} />
                )}
                {darkTitle && title && (
                    <CardHeader sx={{ p: 2.5 }} title={<Typography variant="h4">{title}</Typography>} action={secondary} />
                )}

                {/* content & header divider */}
                {title && (
                   <Box
                   sx={{
                     borderTop: `1px solid ${borderColor}`,
                     opacity: 1,
                     borderColor: theme.palette.mode === 'dark' ? '#ffffff' : theme.palette.primary.light,
                   }}
                   style={{ borderColor: 'black' }} // Add the style attribute outside the sx prop
                 />
                 
                )}

                {/* card content */}
                {content && (
                    <CardContent sx={{ p: 2.5, ...contentSX }} className={contentClass || ''}>
                        {children}
                    </CardContent>
                )}
                {!content && children}
            </Card>
        );
    }
);

SubCard.propTypes = {
    children: PropTypes.node,
    content: PropTypes.bool,
    contentClass: PropTypes.string,
    darkTitle: PropTypes.bool,
    secondary: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.object]),
    sx: PropTypes.object,
    contentSX: PropTypes.object,
    title: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.object])
};

SubCard.defaultProps = {
    content: true
};

export default SubCard;
